import React, { useState, useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Chart } from "primereact/chart";
import { IssuanceService } from "../IssuanceService";
import { Satspertoken } from "../../../App/Satspertoken";
import configData from "../../../App/Config.json";

// page for displaying chaertdata
// const ConfirmTransferCBTrans = ({ data, setData }) => {

const urlname = configData.baseurl;
/*
function satisfy( assets, symbol, balance) {
	console.log(assets);
        var pp = assets.filter(xx=>{
          if(xx.issuetype == symbol) return true;
        });
       console.log(pp);
       console.log(symbol);
	if(pp[0] && Number.isInteger(pp[0].satspertoken)) {
          return (balance/pp[0].satspertoken).toFixed(2);
	} else {
	  return balance.toFixed(2);
	}
}
*/

const CBDCAssets = ({
  allassets,
  data1,
  setData1,
  user,
  token,
  transactionhappened,
  balances,
  accountowners,
}) => {
  // initail value for chart data

  const [loading, setLoading] = useState(1);
  const [data, setData] = useState();
  // {
  //   labels: ["Digital_$_Frank", "Digital_Euro"],
  //   datasets: [
  //     {
  //       data: [10000.0, 16000.0],
  //       backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
  //       hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
  //     },
  //   ],
  // }
  const [amount, setAmount] = useState([]);
  const [issuetype, setIssuetype] = useState([]);
  const issuanceservice = new IssuanceService();
  const satspertoken = new Satspertoken();

  const [accountnumber, setAccountnumber] = useState("");
  const [address, setAddress] = useState("");
  /*

  useEffect(() => {
         if(accountnumber != '') {
         issuanceservice.getaddressfromaccountnumber(accountnumber).then((res) => {
		 setAddress(res.address);
         });
         }
  }, [accountnumber])
*/
  useEffect(() => {
    setLoading(1);
    issuanceservice.getcentralaccount().then((res) => {
      setAccountnumber(res.accountnumber);
    });
  }, []);
  useEffect(() => {
    if (amount.length > 0) {
      setLoading(2);
    } else {
      setLoading(1);
    }
  }, [amount]);

  useEffect(() => {
    //fetch data from api
    const fetchData = async () => {
      const dataset1 = [];
      const dataset2 = [];

      if (balances.balances) {
        balances.balances.forEach((xx) => {
          if (xx.address == user.centraladdress) {
            if (xx.tokens) {
              xx.tokens.forEach((yy) => {
                dataset1.push(
                  satspertoken.satisfy(allassets, yy.symbol, yy.balance)
                );
                dataset2.push(yy.symbol);
              });
            }
          }
        });
      }
      setData({
        labels: dataset2,
        datasets: [
          {
            data: dataset1,
            backgroundColor: ["#1569BB", "#00C6AE", "#36A2EB", "#6B7280"],
            hoverBackgroundColor: ["#1a85ed", "#00f7d9", "#4bb3fa", "#7f8694"],
          },
        ],
      });
      setAmount(dataset1);
      setIssuetype(dataset2);
      console.log("arrData", dataset1, dataset2);
    };

    fetchData();
  }, [balances, allassets, user.centraladdress, transactionhappened]);

  const [lightOptions] = useState({
    indexAxis: "x",
    elements: {
      doughnut: {
        borderWidth: 2,
      },
    },
    plugins: {
      legend: {
        position: "right",
        labels: {
          color: "#eee",
        },
      },
      title: {
        display: true,
        text: "",
        color: "#eee",
      },
    },
  });

  // const dataset3 = [];

  // for (const val of data) {
  //   dataset3.push(val.amount);
  // }

  // console.log(dataset3);
  // const value = amount.reduce((a, b) => a + b, 0);
  // console.log(value);
  return (
    <>
      <div className="col-12 ">
        <div className="grid p-fluid">
          <div className="col-12 md:col-6 ">
            <div className="card border-1 border-300 bg-gray-800  mt-3 card-w-title">
              <p className="border-bottom-1 pb-2 text-3xl">CBDC</p>
              {issuetype.map((cdata, index) => (
                <div className="list-disc">
                  <li className="text-2xl pb-2" key={index}>
                    {cdata}{" "}
                  </li>
                </div>
              ))}
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="card border-1 border-300 bg-gray-800  mt-3  card-w-title">
              <p className="border-bottom-1 pb-2 text-3xl">Total assets</p>
              {amount.map((cdata, index) => (
                <div className="list-disc">
                  <li className="text-2xl pb-2" key={index}>
                    {cdata}{" "}
                  </li>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="  flex flex-column align-items-center ">
        {loading == 1 ? (
          <div>
            <ProgressSpinner
              style={{ width: "80px", height: "80px" }}
              // strokeWidth="8"
              fill="var(--surface-ground)"
              animationDuration=".8s"
            />
          </div>
        ) : (
          ""
        )}

        <Chart
          type="doughnut"
          data={data}
          options={lightOptions}
          className="w-9 md:w-7"
          style={{
            position: "relative",
            // width: "60%",
            justifyContent: "center",
          }}
        />
      </div>
    </>
  );
};

export default CBDCAssets;
